// Never use zero as an id, it is reserved for "no sound"
const NotificationSounds = [{
  duration: 1,
  id: 1,
  name: 'Chime'
}, {
  duration: 1,
  id: 2,
  name: 'Whizz'
}, {
  duration: 2,
  id: 3,
  name: 'Ping-pong'
}, {
  duration: 2,
  id: 4,
  name: 'Jingle'
}, {
  duration: 4,
  id: 5,
  name: 'Roll'
}, {
  duration: 12,
  id: 6,
  name: 'Long Call'
}];
export const getNotificationSoundsWithIds = () => NotificationSounds;
export const getSoundDurationInSeconds = name => {
  const requestedSound = NotificationSounds.find(sound => sound.name === name);
  return requestedSound ? requestedSound.duration : 0;
};